import { rem } from "polished";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

export const VideoAndParagraphList = withViewportStyle("div")`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${rem(112)};

  ${(props) => props.$viewport.tablet` 
    grid-gap: ${rem(24)};
    `}

  ${(props) => props.$viewport.mobile` 
    grid-template-columns: auto;
    `}

  iframe {
    border-radius: ${rem(20)};
  }
`;
